import { Endpoints } from '@/api/ApiEndpoints';

const Markets = {
	Plural: 'Markets',
	Single: 'Market',
	ModalForm: true,
	DefaultSorting: 'ID',
	DefaultSortingType: 'ASC',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
		},
		
		
	],
	Filters: [],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/markets/add/',
		editLink: '/markets/edit/',
		
	},
};

export default Markets;
